module.exports = __webpack_public_path__ + "static/media/laminat.3fe1ed8a.png";